import { render, staticRenderFns } from "./SnapshotWrapper.vue?vue&type=template&id=804fb1ea&scoped=true&"
import script from "./SnapshotWrapper.vue?vue&type=script&lang=js&"
export * from "./SnapshotWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SnapshotWrapper.vue?vue&type=style&index=0&id=804fb1ea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../.yarn/__virtual__/vue-loader-virtual-783d792af9/0/cache/vue-loader-npm-15.10.0-778eb54c35-1bf6c9ffea.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804fb1ea",
  null
  
)

export default component.exports